module.exports = __webpack_public_path__ + "static/media/backup-file.2d3b1891.svg";